import { Position } from '../../models/Position';
import * as _ from 'lodash';

/**
 * Moves widgets according to column count. Adds the printPosition property with corrected values.
 * @param widgets The list of widgets to reposition.
 * @param nCol The destination number of columns.
 * @returns The list of mutated repositioned widgets.
 */
export function changeColumnNumber<T extends (Position & { printPosition?: Position })>(widgets: T[], nCol: number): T[] {
    const grouped = _.groupBy(widgets, w => w.row);
    let offset = 0;
    let globalOffset = 0;
    const result = [];
    let hasPreviousMoved = false;
    let previousPosition: Position;
    for (const key of Object.keys(grouped)) {
        let currentWidgets: T[] = grouped[key];
        currentWidgets = _.sortBy(currentWidgets, w => w.col);
        currentWidgets.forEach((w, i) => {
            const sizeX = w.sizeX;
            const sizeY = w.sizeY;
            let row = w.row + globalOffset;
            let col = w.col;
            if (hasPreviousMoved && previousPosition) {
                row = previousPosition.row;
                col = previousPosition.sizeX + previousPosition.col;
            }

            const position = pos(sizeX, sizeY, row, col, offset, nCol);
            w.printPosition = position.position;
            hasPreviousMoved = position.hasMoved;
            previousPosition = position.position;
            offset = previousPosition.sizeY;
            if (hasPreviousMoved) {
                globalOffset += offset;
            }
            result.push(w);
        });
    }
    return result;
}


function pos(sizeX, sizeY, row, col, offset, nCol) {
    let hasMoved = false;
    //too big => decrease size
    if (sizeX >= nCol) {
        sizeX = nCol;
    }

    //overflows on the right: push item x rows lower
    if (col >= nCol || col + sizeX > nCol) {
        row += offset;
        col = 0;
        hasMoved = true;
    }

    const position = new Position(sizeX, sizeY, col, row);
    return {
        position: position,
        hasMoved: hasMoved
    };
}